import { withStyles } from '@material-ui/core';
import { MixedBanner } from '../../api/models';
import BaseDisplay, { BaseRealProps } from '../basedisplay/BaseDisplay';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { commonFeatureActions } from '../../features/commonfeature';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { nullStringInMapToNull } from '../../utils';

const styles = {
    container: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginTop: '3%',
        paddingTop: '3%',
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
})

const mapDispatchToProps = (dispatch: Dispatch<MyTypes.RootAction>) => 
    bindActionCreators(
        {
            createMixedBanner: commonFeatureActions.createMixedBanner,
            patchMixedBanner: commonFeatureActions.patchMixedBanner,
            showMessage: commonFeatureActions.showMessage
        },
        dispatch
    )

/** Callback the page passes in to open the campaign banner dialog. */
type CampaignDialogProps = {
    onTagCampaignRequested?: (row: any) => void
}

type MyProps<A> = BaseRealProps<A> & ReturnType<typeof mapDispatchToProps> & CampaignDialogProps

/**
 * The inline add row renders every editable column, so types other than the
 * chosen one arrive as `""`. The admin schema is strict, so blanks are dropped
 * instead of being posted as empty strings.
 */
const pruneBlankFields = (row: any): any => {
    const pruned: any = {};
    Object.keys(row).forEach(key => {
        const value = row[key];
        if (value === '' || value == null) {
            return;
        }
        pruned[key] = value;
    });
    return pruned;
}

/**
 * TASK-52: the banner type is never inferred. Ops picks it from the grid's Type
 * dropdown. A `tag` campaign needs a multi-select that the inline add row cannot
 * render, so it is handed to the campaign banner dialog instead of being posted
 * from here.
 */
const onRowAdded = (row: any, props: any) => {
    console.log('Mixed Banner onRowAdded', row, props);
    const published = row['published'];
    row['published'] = published === '1' || published === 'true' || published === 't';

    const type = row['type'];
    if (type == null || type === '') {
        props.showMessage({ message: 'Pick a Type before saving the banner' });
        return;
    }
    if (type === 'tag') {
        if (props.onTagCampaignRequested != null) {
            props.onTagCampaignRequested(row);
        } else {
            props.showMessage({ message: 'Tag campaigns are created from the campaign banner dialog' });
        }
        return;
    }
    (props as unknown as MyProps<MixedBanner>).createMixedBanner(pruneBlankFields(row));
}

class MixedBannerDisplay extends BaseDisplay<MixedBanner, MyProps<MixedBanner>> {
    static defaultProps = {
        ...BaseDisplay.defaultProps,
        header: 'Mixed Banner',
        onRowAdded: onRowAdded,
        onRowEdited: (row: any, props: MyProps<MixedBanner>, entity: any) => {
            let entityId = entity.id
            nullStringInMapToNull(row);
            props.patchMixedBanner({id: entityId, args: row})
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(MixedBannerDisplay)))
